import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import headerbg from "../../assets/svg/header-bg.svg";
import googlepng from "../../assets/png/google.png";
import meta from "../../assets/png/meta.png";
import amazon from "../../assets/png/amazon.png";
import apple from "../../assets/png/apple.png";
import spotify from "../../assets/png/spotify.png";
import microsoft from "../../assets/png/microsoft.png";
import CustomButton from "../../components/shared/buttons/CustomButton";
import { useModal } from "../../hooks/useModal";

import Index from "../auth/Index";
import Modal from "../../components/common/Modal";

const Header = () => {
  const { isOpen, openModal, closeModal } = useModal();
  const navigate = useNavigate();
  const { user, token } = useSelector((state) => state.auth);



  const isAuthenticated = !!token;

  
  const getDashboardPath = () => {
    return user?.role === "admin" ? "/admin/courses" : "/student/courses";
  };

 
  const handleButtonClick = () => {
    if (isAuthenticated) {
      navigate(getDashboardPath());
    } else {
      openModal();
    }
  };

  const companyLogos = [
    { src: googlepng, alt: "Google" },
    { src: meta, alt: "Meta" },
    { src: amazon, alt: "Amazon" },
    { src: apple, alt: "Apple" },
    { src: spotify, alt: "Spotify" },
    { src: microsoft, alt: "Microsoft" },
  ];

  return (
    <>
      <header className="flex flex-col justify-center items-center max-w-7xl mx-auto px-4 py-16">
        <h1 className="text-5xl font-bold text-center mb-6 max-w-3xl">
          The{" "}
          <span className="inline-block bg-[linear-gradient(90deg,#1B3673_0%,#F5A404_25%,#1B2873_46%,#28DCFA_60%,#217FB4_76%,#25B6DE_89%,#28E2FF_100%)] bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient">
            Fastest
          </span>{" "}
          Track to a Successful Data Engineering Career
        </h1>

        <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl">
          Accelerate your data engineering career with our structured
          curriculum, hands-on projects, and expert mentorship designed to help
          you seamlessly transition into high-growth roles.
        </p>

        <div className="relative w-full max-w-4xl mb-12 rounded-xl overflow-hidden">
          <img
            src={headerbg}
            alt="mentorhub"
            className="w-full h-auto rounded-xl"
          />

          <div className="absolute inset-0 flex items-center justify-center">
            <iframe
              width="500"
              height="315"
              src="https://www.youtube.com/embed/PHsC_t0j1dU?si=rlLDiPp3U1md7UIr"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="rounded-xl mt-4"
            ></iframe>
          </div>
        </div>

        <CustomButton
          variant="primary"
          fullWidth={false}
          onClick={handleButtonClick}
          className="mb-12 w-1/4 h-16 text-2xl"
        >
          {isAuthenticated ? "Go to Dashboard" : "Get Started"}
        </CustomButton>

        <p className="text-gray-600 mb-8 text-center">
          Become one of over 1 million developers building careers at top
          companies like:
        </p>

        <div className="w-full max-w-4xl">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 flex-wrap">
            {companyLogos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-h-10 w-auto opacity-75 hover:opacity-100 transition-opacity duration-200"
                />
              </div>
            ))}
          </div>
        </div>
      </header>

      {/* Only render the modal if user is not authenticated */}
      {!isAuthenticated && (
        <Modal isOpen={isOpen} onClose={closeModal}>
          <Index onLoginSuccess={closeModal} />
        </Modal>
      )}
    </>
  );
};

export default Header;
